import { logger } from '../services';

export const logInfo = (namespace: string, methods: string, params: any = {}): void => {
  logger.info(`[${namespace}] ${methods}`, params);
};
